import FlashOverlayModal from "./js/FlashOverlayModal";
export default FlashOverlayModal;
